import { CheckoutState } from '../../state';
import { isEventbriteTLDInDevOrQAEnv } from '../../utils/browser';
import { isEventbriteTLD, isIosApp } from '../app';

export const isTLDWithApplePayEnabled = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv() || isIosApp(state);
